export default __webpack_public_path__ + "canvas.1947a6.svg";